import { routes } from "../General";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Card, CardBody, CardTitle, Label } from "reactstrap";
import { TourStart } from "../../tour/TourStart";
import Alerts from "../../util/Alerts";
import BlkFormik from "../../coms/BlkFormik";
import { Form } from "formik";
import { BlkField } from "../../coms/BlkField";
import { ArchivoPreview } from "../../coms/archivos/ArchivoPreview";
import { ArchivoUpload } from "../../coms/archivos/ArchivoUpload";
import { formularioCredito, formularioVam } from "./validacion";
import { JedaiCantidades } from "../../coms/JedaiCantidades";
import { FormikSave } from "../../coms/FormikSave";
import { Confirmacion } from "../../gen/zoho/FormularioZoho";
import { ModalEspere } from "../../gen/zoho/ModalEspere";
import JedaiTooltip from "../../coms/JedaiTooltip";
import { MAX_TOTAL_SIZE_FILES } from "../../coms/archivos/util";
import Humanize from "humanize-plus";
import { filterInactiveInsureds } from "../../util/portals.utils";

export const efiZohoFields = () => {
    return {
        a1: "",
        a2: "",
        a3: "",
        diagnostico: "",
        celularT: "",
        centroMedico: "",
        medico: "",
        valorPresupuestado: "",
        observacionesHp: "",
        observaciones: "",
        poliza: "",
        files: [],
    };
};
export const FormularioZohoVam = props => {
    const alert = React.useRef();
    const signaturePadRef = React.createRef();
    const [list, setList] = useState([]);
    const [item, setItem] = useState({});
    const [pacientes, setPacientes] = useState([]);
    const [paciente, setPaciente] = useState({});
    const [formulario, setFormulario] = useState(efiZohoFields());
    const user = useSelector(state => state.user);
    const [modulo, setModulo] = useState({ moduloDoc: false });
    const [totalSizeFiles, setTotalSizeFiles] = useState(0); // para verificar que totos los archivos no pasen los MB permitidos

    useEffect(() => {
        getAseguradora();
        setFormulario({
            credito: false,
            subject: null,
            cedulaC: null,
            nombreT: null,
            cedulaT: null,
            paciente: null,
            aseguradora: null,
            emailT: null,
            celularT: "",
            plan: null,
            files: [],
            diagnostico: "",
            centroMedico: null,
            escanea: user.usuario,
            ...efiZohoFields(),
        });
    }, [user]);

    const getAseguradora = () => {
        let hospitalario = props?.hospitalario ? props?.hospitalario : false;
        axios
            .get(routes.api + "/siniestro/deducible/matrix", {
                params: {
                    cedula: user.cedula, // siemre esta aqui la ced correcta, ver combo titular en poliza
                    caducada: true,
                    hospitalario: hospitalario,
                },
            })
            .then(resp => {
                resp.data?.forEach(item => {
                    item.items = filterInactiveInsureds(item?.items);
                });
                setList(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    };

    const buildUrl = (item, paciente, values, a3) => {
        //aqui cuando es titular el titular es el usuario logeado de ahi se saco los datos
        //y la firma es un archivo digital
        let cltx = item?.NM_CLIENTE;
        if (item?.AP_CLIENTE) {
            cltx = item?.AP_CLIENTE + " " + item?.NM_CLIENTE;
        }

        let tmp = { ...values, a3 };
        tmp.credito = props.zoho2;
        tmp.subject = cltx;
        tmp.cedulaC = item?.RUC_CED;
        tmp.nombreT = item?.DSC_OBJETO;
        tmp.cedulaT = item?.CEDULA_O;
        tmp.paciente = paciente?.NOMBRES;
        tmp.aseguradora = item?.ASEGURADORA;
        tmp.emailT = item?.CORREO;
        tmp.celularT = item?.CELULAR;
        tmp.plan = item?.DSC_PLAN;
        tmp.cdCliente = item?.CD_CLIENTE;
        tmp.files = undefined;
        tmp.firma = undefined;
        tmp.poliza = item?.POLIZA || "";
        if (paciente?.FC_NACIMIENTO) {
            let part = paciente?.FC_NACIMIENTO?.split("T")[0];
            let part2 = part.split("-");
            tmp.fechaNacimiento = part2[0] + "-" + part2[1] + "-" + part2[2];
        }
        setFormulario(tmp);
    };

    const onSubmit = (newValues, actions) => {
        let formData = new FormData();
        if (newValues.files && newValues.files.length > 0) {
            newValues.files?.forEach(file => {
                formData.append("files", file);
            });
            newValues.files = undefined;
        } else {
            alert.current.show_error("Debe al menos subir un archivo");
            actions.setSubmitting(false);
            return;
        }
        newValues.siniestro = props.siniestro;
        formData.append("item", new Blob([JSON.stringify(newValues)], { type: "application/json" }));
        axios
            .post(routes.api + "/ticket/crear", formData, {
                headers: {
                    "content-Type": "multipart/form-data",
                },
            })
            .then(resp => {
                let data = resp.data;
                //alert.current.show_info(data);
                showConfirmacion(true);
                actions.setSubmitting(false);
            })
            .catch(error => {
                alert.current.show_error(
                    `El ticket no se ha creado correctamente. ${error.response?.data?.errors[0]?.errorMessage ?? "Contáctese con soporte"}`
                );
            })
            .finally(() => {
                actions.setSubmitting(false);
            });
    };

    const handleClear = setFieldValue => {
        const signaturePad = signaturePadRef.current;
        if (signaturePad) {
            signaturePad.instance.clear();
            setFieldValue("firma", null);
        }
    };

    const showConfirmacion = open => {
        setModulo({ moduloDoc: open });
    };

    const handleTotalSize = (size, operator = "+") => {
        if (operator == "+") {
            setTotalSizeFiles(totalSizeFiles + size);
        } else {
            setTotalSizeFiles(totalSizeFiles - size);
        }
    };

    return (
        <div className="content">
            <Alerts ref={alert} />
            <Card className={"bg-primary"}>
                <CardBody>
                    {props.zoho2 === true ? (
                        <CardTitle tag="h4" className={"text-white"}>
                            Documento Crédito Hospitalario/Ambulatorio
                        </CardTitle>
                    ) : (
                        <CardTitle tag="h4" className={"text-white"}>
                            Documento Asistencia Médica
                        </CardTitle>
                    )}
                    <div className={"d-block text-center text-primary"}>
                        <TourStart type={"documentos-vam"} auto={false} />
                    </div>
                    <div className="row">
                        <div className="col">
                            <BlkFormik
                                initialValues={formulario}
                                onSubmit={onSubmit}
                                enableReinitialize={true}
                                validateOnChange={false}
                                validationSchema={props.zoho2 ? formularioCredito : formularioVam}
                            >
                                {({ values, isSubmitting, setFieldValue, submitForm }) => (
                                    <Form>
                                        <div className="row">
                                            <div className="form-group col-lg-6" id={"combo_aseg_vam"}>
                                                <Label>Aseguradora / Plan</Label>
                                                <BlkField
                                                    component={"select"}
                                                    className="form-control"
                                                    onChange={e => {
                                                        let it = list.find(
                                                            a =>
                                                                a.CD_COTIZACION + "_" + a.CD_UBICACION ===
                                                                e.target.value
                                                        );
                                                        setItem(it);
                                                        let pacientes = [];
                                                        it?.items?.forEach(x => pacientes.push(x));
                                                        let pac = pacientes?.length > 0 ? pacientes[0] : {};
                                                        setPaciente(pac);
                                                        setPacientes(pacientes);
                                                        setFieldValue("a1", e.target.value);
                                                        setFieldValue("a2", pac?.NOMBRES ? pac.NOMBRES : "");
                                                        setFieldValue("a3", "");
                                                        buildUrl(
                                                            it,
                                                            pac,
                                                            {
                                                                ...values,
                                                                a1: e.target.value,
                                                                a2: pac?.NOMBRES ? pac.NOMBRES : "",
                                                            },
                                                            pac?.NOMBRES
                                                        );
                                                    }}
                                                    name={"a1"}
                                                >
                                                    <option value={0}>--Seleccione--</option>
                                                    {list?.map(a => (
                                                        <option
                                                            value={a.CD_COTIZACION + "_" + a.CD_UBICACION}
                                                            key={a.CD_COTIZACION + "_" + a.CD_UBICACION}
                                                        >
                                                            {a?.ASEGURADORA}/{a?.DSC_UBICACION}/{a?.DSC_PLAN}
                                                        </option>
                                                    ))}
                                                </BlkField>
                                            </div>
                                            <div className="form-group col-lg-6" id={"combo_paciente_vam"}>
                                                <Label>Paciente</Label>
                                                <BlkField
                                                    component={"select"}
                                                    className="form-control"
                                                    value={paciente?.NOMBRES}
                                                    onChange={e => {
                                                        let pac = pacientes?.find(a => a?.NOMBRES === e?.target?.value);
                                                        setPaciente(pac);
                                                        buildUrl(item, pac, values, e.target.value);
                                                        setFieldValue("a2", e.target.value);
                                                    }}
                                                    name={"a2"}
                                                >
                                                    <option value={0}>--Seleccione--</option>
                                                    {pacientes.map(a => (
                                                        <option value={a.NOMBRES} key={a.NOMBRES}>
                                                            {a.NOMBRES}
                                                        </option>
                                                    ))}
                                                </BlkField>
                                            </div>
                                        </div>
                                        {props.zoho2 === true ? (
                                            <div className="row">
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Plan Contratado:</Label>
                                                    <BlkField className="form-control" type="text" name={"plan"} />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Diagnóstico:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        name={"diagnostico"}
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Celular Contacto:</Label>
                                                    <BlkField className="form-control" type="text" name={"celularT"} />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Centro Médico:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        name={"centroMedico"}
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Médico tratante:</Label>
                                                    <BlkField className="form-control" type="text" name="medico" />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Valor Presupuestado:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        component={JedaiCantidades}
                                                        step={0.01}
                                                        name={"valorPresupuestado"}
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>
                                                        Observaciones o Instrucciones especiales para cada crédito:
                                                    </Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        component="textarea"
                                                        placeholder="Observaciones"
                                                        name={"observacionesHp"}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="row">
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Diagnóstico:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        name={"diagnostico"}
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Celular Contacto:</Label>
                                                    <BlkField className="form-control" type="text" name={"celularT"} />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Observaciones o instrucciones especiales:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        component="textarea"
                                                        placeholder="Observaciones"
                                                        name={"observaciones"}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div className="row">
                                            <div className="col">
                                                <Label>Carga de archivos:</Label>
                                                <div className="files">
                                                    <ArchivoPreview values={values} edit={isSubmitting} />
                                                    {!isSubmitting && (
                                                        <ArchivoUpload
                                                            id={"archivo"}
                                                            values={values}
                                                            maxFileSize={"20MB"}
                                                            setFieldValue={setFieldValue}
                                                            handleTotalSize={handleTotalSize}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <FormikSave
                                                    type="button"
                                                    className="btn btn-secondary my-2"
                                                    disabled={isSubmitting || totalSizeFiles > MAX_TOTAL_SIZE_FILES}
                                                    onClick={submitForm}
                                                />
                                                <span>
                                                    &nbsp;
                                                    <JedaiTooltip
                                                        message={`El peso total permitido es (${Humanize.fileSize(MAX_TOTAL_SIZE_FILES)})`}
                                                    >
                                                        <i className={"fa fa-info-circle text-white"} />
                                                    </JedaiTooltip>
                                                </span>
                                            </div>
                                        </div>
                                        <div className={"modal-espere"}>
                                            <ModalEspere open={isSubmitting} />
                                        </div>
                                    </Form>
                                )}
                            </BlkFormik>
                        </div>
                    </div>
                </CardBody>
            </Card>
            <Confirmacion open={modulo.moduloDoc} toggleModal={showConfirmacion} onClose={props.onClose} />
        </div>
    );
};
